import React, { useState } from "react";
import { adminLogin } from "../../../State/AuthSlice";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { Button, CircularProgress, Paper, TextField, Alert, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";

const AdminLoginForm = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { auth } = useAppSelector((store) => store);
    const [showPassword, setShowPassword] = useState(false);

    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Admin Email / Username is required"),
            password: Yup.string().required("Password is required"),
        }),
        onSubmit: (values) => {
            const formattedPayload = {
                email: values.email.trim(),
                password: values.password,
            };

            dispatch(adminLogin({ loginRequest: formattedPayload, navigate }));
        },
    });

    return (
        <div className="w-full min-h-[80vh] flex items-center justify-center px-4 py-8 sm:px-6 lg:px-8">
            <Paper elevation={3} className="w-full max-w-md p-6 sm:p-8 rounded-xl space-y-6">
                <h1 className="text-center font-bold text-2xl sm:text-3xl text-primary-color pb-2">
                    Login As Admin
                </h1>

                {auth.error && (
                    <Alert severity="error" className="mb-2">
                        {auth.error}
                    </Alert>
                )}

                <form onSubmit={formik.handleSubmit} className="space-y-5">
                    <TextField
                        fullWidth
                        id="email"
                        name="email"
                        label="Admin Email / Username"
                        variant="outlined"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={formik.touched.email && formik.errors.email}
                    />

                    <TextField
                        fullWidth
                        id="password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        label="Password"
                        variant="outlined"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.password && Boolean(formik.errors.password)}
                        helperText={formik.touched.password && formik.errors.password}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => setShowPassword(!showPassword)}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        disabled={auth.loading}
                        sx={{ py: "12px", fontSize: "0.95rem", fontWeight: 600 }}
                    >
                        {auth.loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
                    </Button>
                </form>
            </Paper>
        </div>
    );
};

export default AdminLoginForm;